import { createJSONStorage } from "jotai/utils";

export const storage = createJSONStorage<any>(() => sessionStorage);
